import { FaDoorOpen } from "react-icons/fa";

const LogoutIcon = ({ onClick }) => (
    <FaDoorOpen size={24} onClick={onClick} />
);
export default LogoutIcon;